import gql from 'graphql-tag';

export default gql`
  mutation productUpdate($input: ProductInput!) {
    productUpdate(input: $input) {
      success
      userErrors {
        field
        message
      }
      product {
        id
      }
    }
  }
`;
